angular.module('zc.core')
  .filter('humanizeCurrency', humanizeCurrency);

humanizeCurrency.$inject = ['$translate'];
function humanizeCurrency($translate) {
  return function(currency) {
    return $translate.instant(`sharedModules.core.filters.humanizeCurrency.${currency}`);
  };
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/humanize_currency.js